import { createAsync, useParams, type RouteSectionProps } from "@solidjs/router";
import { createEffect, untrack } from "solid-js";
import { NavBar } from "../NavBar";
import { fetchTenantConfig } from "../Scene.data";
import { useSession, organization as orgClient, useListOrganizations } from "../../lib/auth-client";
import { isOrganizationSwitching } from "../signals";
import Notifications from "../Notifications";

export default function TenantLayout(props: RouteSectionProps) {
  const params = useParams();
  const configQuery = createAsync(() => fetchTenantConfig(params.tenantId!));
  const sessionQuery = useSession();
  const organizations = useListOrganizations();

  // Switch organization if URL tenantId doesn't match active organization
  createEffect(() => {
    if (untrack(isOrganizationSwitching)) {
      return;
    }
    const urlTenantId = untrack(() => params.tenantId);

    // Only proceed if we have loaded the session and organizations list
    if (sessionQuery().isPending || organizations().isPending) {
      return;
    }

    if (!sessionQuery().data?.user) return;

    // Get current active org slug from session
    const activeOrgId = sessionQuery().data?.session.activeOrganizationId;
    const currentActiveOrgSlug = activeOrgId
      ? organizations().data?.find((o: any) => o.id === activeOrgId)?.slug
      : undefined;

    // Find the organization by slug
    const targetOrg = organizations().data?.find((o: any) => o.slug === urlTenantId);
    if (!targetOrg) {
      // user doesn't belong to this organization, do nothing
      return;
    }

    // If the URL tenantId doesn't match the current active org
    if (urlTenantId !== undefined && urlTenantId !== currentActiveOrgSlug) {
      // Switch to this organization
      orgClient.setActive({ organizationSlug: urlTenantId });
    }
  });

  return (
    <>
      <NavBar config={configQuery()} />
      {props.children}
      <div class="absolute bottom-2 left-2">
        <Notifications />
      </div>
    </>
  );
}
